import { IUserWithGroup } from '../interfaces/userWithGroup';
import { IPairUserGroup } from '../interfaces/pairUserGroup';
import { IPairUserRole } from '../interfaces/pairUserRole';
import { IPairUserRoleCatalog } from '../interfaces/pairUserRoleCatalog';
import { IPairUserRoleFile } from '../interfaces/pairUserRoleFile';
import { AttachType } from '../enums/attachType';
import { ContractPermission } from '../enums/contractPermission';
import { BrandType } from '../enums/brandType';
import { CustomerVisibilityType } from '../enums/customerVisibility';

export class UserWithGroup implements IUserWithGroup {
    avatar: string;
    email: string;
    firstName: string;
    id: number;
    idGroup: number;
    idRole: number;
    insertDate: Date;
    isDisabled: boolean;
    lastModifiedDate: Date;
    lastName: string;
    contractDelayTolerance: number;
    rUsersGroupsIdGroupNavigation: IPairUserGroup[];
    rUsersRoles: IPairUserRole[];
    rUsersRolesCatalogs: IPairUserRoleCatalog[];
    rUsersRolesFiles: IPairUserRoleFile[];
    thumbnail: string;
    username: string;
    optionalContractAttaches: AttachType[];
    permissionContractsType: ContractPermission;
    canExportContract: boolean;
    canDoExportSemplice: boolean;
    canDoExportGas: boolean;
    canDoExportEe: boolean;
    permitBrands: BrandType[];
    customerVisibility: CustomerVisibilityType;
    canStopContracts: boolean;
    teleselling: boolean;
    reliabilityPercentage: number;
    needVerificationCall: boolean;
    canMoveCustomers: boolean;
    canDoAdesioneADistanza: boolean;
    canHandleStopForErrors: boolean;
    canDoChiamataBenvenuto: boolean;
    canDoPortaUnAmico: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/userWithGroup.ts